module.exports = __webpack_public_path__ + "img/stop-wasting-time.c3f11ec9.webp";